// iconUtils.js
import { FaFigma, FaReact, FaNodeJs } from "react-icons/fa";
import { SiStyledcomponents, SiAdobexd, SiTailwindcss, SiGooglemaps, SiPostgresql, SiExpress, SiMapbox, SiFirebase, SiFlutter } from "react-icons/si";
import { TbBrandFramerMotion } from "react-icons/tb";
// Add more as needed

export const iconMapping = {
  FaFigma,
  FaReact,
  FaNodeJs,
  SiTailwindcss,
  SiStyledcomponents,
  SiExpress,
  TbBrandFramerMotion,
  SiAdobexd,
  SiGooglemaps,
  SiMapbox,
  SiFirebase,
  SiFlutter,
  SiPostgresql,
  // ...add more as needed
};

export function getIconComponent(iconName, size = 20, color) {
  const IconComp = iconMapping[iconName];
  return IconComp ? <IconComp size={size} color={color} /> : null;
}
